import type { LinearProgressProps } from "@mui/material";
import { AppLinearLoading } from "../../../../shared/components/AppLoading/AppLinearLoading";
import styles from "./styles.module.css";

interface Props extends LinearProgressProps {
  uploadInfo: string;
}

export const FileUploadIndicator = ({ uploadInfo, ...props }: Props) => {
  return (
    <div className={styles.container}>
      <p>{uploadInfo}...</p>
      <AppLinearLoading
        variant="indeterminate"
        className={styles["linear-loading"]}
        {...props}
      />
    </div>
  );
};
